









import TitleBar from '../pages/goods-new/comps/TitleBar.vue'
import { Component, Vue } from 'vue-property-decorator'
@Component({
  components: {
    TitleBar,
  },
})
export default class PicPage extends Vue {
  image: any = ''
  isApp: any = false
  navbarHeight: number
  async created() {
    this.image = this.$route.query.src
    this.isApp = this.$route.query.isApp === 'true'
    this.navbarHeight = Number(this.$route.query.height) || 25
  }
}
